import { BenefitBrand, OTTSubscription, TvBenefitType } from './assigned-product.types';

export enum TvBenefitEligibilityEnum {
  ALLOWED = 'ALLOWED',
  BUNDLECHANGEREQUIRED = 'BUNDLE_CHANGE_REQUIRED',
  CONTENTOVERLAP = 'CONTENT_OVERLAP',
  CANCELLATION = 'CANCELLATION',
  NEWORDER = 'NEW_ORDER',
}

export interface TvBenefit {
  televisionPackageId: string;
  name: TvBenefitType;
  brand: BenefitBrand;
  eligibility: TvBenefitEligibilityEnum;
  eligibilityReason?: string | null;
  subscription?: OTTSubscription | null;
}

export interface AssignedBenefit {
  changeAllowedAfterDate: string | null;
  benefit: TvBenefit;
}

export interface PendingTvBenefitName {
  name: string;
}

export interface SuccessResponse {
  success: boolean;
}
